module.exports = __webpack_public_path__ + "img/side invisible zipper length.f9cfd7a1.png";